import React, { useState } from 'react';
import { Heart, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { wishlistStore, useWishlistIds } from '../services/wishlistStore';
import { useT } from '../services/i18n';

const WishlistButton = ({ productId, size = 18, className = '', showLabel = false }) => {
  const { t } = useT();
  const ids = useWishlistIds();
  const [busy, setBusy] = useState(false);
  const active = ids.includes(String(productId));

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const added = await wishlistStore.toggle(productId);
      toast(added ? t('wishlist.added') : t('wishlist.removed'));
    } catch {
      toast.error(t('wishlist.error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={`wishlist-toggle-${productId}`}
      data-active={active}
      aria-pressed={active}
      aria-label={active ? t('wishlist.remove') : t('wishlist.add')}
      title={active ? t('wishlist.remove') : t('wishlist.add')}
      onClick={toggle}
      className={`inline-flex items-center gap-1.5 rounded-full transition-all ${showLabel ? 'px-3 h-11 border border-gray-300 hover:border-red-300 text-sm' : 'p-1.5 hover:bg-red-50'} ${active ? 'text-red-500' : 'text-gray-400 hover:text-red-500'} ${className}`}
    >
      {busy ? <Loader2 size={size} className="animate-spin" /> : <Heart size={size} className={active ? 'fill-red-500' : ''} />}
      {showLabel && <span className={active ? 'text-red-600' : 'text-gray-700'}>{active ? t('wishlist.inList') : t('wishlist.addToList')}</span>}
    </button>
  );
};

export default WishlistButton;
